import { createContext, useContext } from "react";
import { isGeMarkedCountry } from "@/libs/global-e/marker";

// 카트 단위 GE 표시 컨텍스트.
//
// ★2026-08-20 이전에는 **carrier 판정**(`classify-by-sku`)도 여기 실려 있었다. 무게·배터리로
// GE 체크아웃 vs 자체 결제를 가르던 게이트인데, GE 협의로 **비-KR 주문은 전부 GE 결제**가 됐다
// (배터리 3개 이상은 GE Admin 에서 운송사만 비햅틱스 자체배송(DDP)으로 변경). 게이트가 사라져
// `geEligible`·`isResolving`·`bulkInquiryRequired` 를 걷어냈고, **남은 축은 Fixed 여부 하나**다.
//
// - **카트 밖(PDP/카드)엔 provider 없음** → 기본값(isFixed=false) → GePrice 는 country 기준.
export interface CartGeEligibility {
  // Fixed 카트(US/EU/GB, Option 1) = 우리가 최종가 제공 → GE 가 DOM 변환/합산하면 깨진다
  // (US 카트 총액 오작동 사례). true 면 가격 마커(data-ge-price/basket) 억제 + 우리 총액 표시
  // (결제는 GetCheckoutCartInfo API). Dynamic(AU 등)=false → GE 가 변환/합산(정상 경로).
  isFixed: boolean;
}

const DEFAULT: CartGeEligibility = { isFixed: false };

export const CartGeEligibilityContext =
  createContext<CartGeEligibility>(DEFAULT);

/** 카트시트 하위에서 소비. provider 밖이면 기본값(isFixed=false = 현행). */
export function useCartGeEligibility(): CartGeEligibility {
  return useContext(CartGeEligibilityContext);
}

/**
 * GE **표시 마커**(`data-ge-price` / `data-ge-basket-*`) 부착 여부의 단일 판정 —
 * 비-KR(commerce country) + Dynamic(!isFixed) 을 **모두** 만족할 때만 true.
 * 가격·합계·라인아이템(cartitemid) 등 **모든 GE 표시 마커가 이 하나를 공유**해야 "일부만 붙는"
 * 부분 마커 상태를 원천 차단한다.
 * provider 밖(PDP/카드)은 기본값(isFixed=false) → country 기준(현행).
 */
export function useGeDisplayMarked(countryCode?: string | null): boolean {
  const { isFixed } = useCartGeEligibility();
  return isGeMarkedCountry(countryCode) && !isFixed;
}
